import { SlotID } from '@/constant';

export function removeBeforeFirstDash(str: string) {
  const index = str.indexOf('-');
  if (index === -1) {
    // 如果字符串中没有 "-", 返回原字符串或空字符串
    return str; // 或者 return '';
  }
  return str.slice(index + 1); // 从第一个 "-" 的下一个字符开始截取
}

export function prettyObject(msg: any) {
  const obj = msg;
  if (typeof msg !== 'string') {
    msg = JSON.stringify(msg, null, '  '); // eslint-disable-line
  }
  if (msg === '{}') {
    return obj.toString();
  }
  if (msg.startsWith('```json')) {
    return msg;
  }
  return ['```json', msg, '```'].join('\n');
}

export function obj2Query(obj: Record<string, any>) {
  if (Object.prototype.toString.call(obj) !== '[object Object]') return '';
  const query = Object.keys(obj).reduce((pre, key) => {
    return `${pre}&${key}=${obj[key]}`;
  }, '');
  return query?.slice(1) || '';
}

export function getQueryParams(queryStr: string) {
  let _queryStr = queryStr;
  if (queryStr.startsWith('?')) {
    _queryStr = queryStr.slice(1);
  }
  const keyValuePairs = _queryStr.split('&').map((pair) => pair.split('='));
  return keyValuePairs.reduce((params: any, [key, value]) => {
    if (key) {
      return {
        ...params,
        [key]: value,
      };
    }
  }, {});
}

export function isNil(value: any) {
  return value === null || value === undefined;
}

export function getAppInfoTitle(url: string) {
  if (url.indexOf('/company/detail') !== -1) {
    return '企业详情';
  } else if (url.indexOf('/bid/detail') !== -1) {
    return '项目详情';
  } else if (url.indexOf('/policy/detail') !== -1) {
    return '政策详情';
  } else if (url.indexOf('/article/detail') !== -1) {
    return '文章详情';
  }
  return '';
}

// 判断列表浮层形式，并关闭浮层
export const judgeIfSiderBarModal = () => {
  const bar = document.getElementById(SlotID.SideBar);
  if (bar && bar.parentElement && bar.parentElement.style.zIndex) {
    // @ts-ignore
    bar.parentElement.previousElementSibling?.click();
  }
};

export function timestamp2string(timestamp: number) {
  const date = new Date(timestamp * 1000);
  const year = date.getFullYear().toString();
  let month = (date.getMonth() + 1).toString();
  let day = date.getDate().toString();
  let hour = date.getHours().toString();
  let minute = date.getMinutes().toString();
  let second = date.getSeconds().toString();
  if (month.length === 1) {
    month = '0' + month;
  }
  if (day.length === 1) {
    day = '0' + day;
  }
  if (hour.length === 1) {
    hour = '0' + hour;
  }
  if (minute.length === 1) {
    minute = '0' + minute;
  }
  if (second.length === 1) {
    second = '0' + second;
  }
  return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
}

export function renderNumber(num: number) {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1) + 'B';
  } else if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  } else if (num >= 10000) {
    return (num / 1000).toFixed(1) + 'k';
  } else {
    return num;
  }
}

export function getHost() {
  //   return `https://te-dx.envsearch.com/waterbase`;
  return HOST;
}

export function encodeForDetectUrlInstructions(data: any): string {
  const jsonStr = JSON.stringify(data);

  // 用TextEncoder处理UTF-8
  const utf8Bytes = new TextEncoder().encode(jsonStr);
  let binaryString = '';
  for (let i = 0; i < utf8Bytes.length; i++) {
    binaryString += String.fromCharCode(utf8Bytes[i]);
  }

  return btoa(binaryString);
}
